export default {
    getApiUrl(uri) {
        return `/api/${uri}`;
    },
};
